import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SameDayDeliveryCountDownComponent } from '@shared/same-day-delivery/same-day-delivery-count-down/same-day-delivery-count-down.component';
import { SameDayDeliveryComponent } from '@shared/same-day-delivery/same-day-delivery/same-day-delivery.component';
import { FormElementsModule } from '@shared/form-elements/form-elements.module';
import { SharedModule } from '@shared/shared.module';
import { TimeRemainingPipe } from '@shared/same-day-delivery/time-remaining.pipe';
import { TimeLimitPipe } from './time-limit.pipe';
import { FormsModule } from '@angular/forms';
import { CustomTimerPipe } from './custom-timer.pipe';
import { SameDayDeliveryInOffModeDirective } from './same-day-delivery-in-off-mode.directive';

@NgModule({
    imports: [CommonModule, SharedModule, FormElementsModule, FormsModule, TimeRemainingPipe,
        SameDayDeliveryCountDownComponent,
        SameDayDeliveryComponent,
        TimeLimitPipe,
        CustomTimerPipe,
        SameDayDeliveryInOffModeDirective],
    providers: [DatePipe],
    exports: [
        SameDayDeliveryComponent,
        SameDayDeliveryCountDownComponent,
        TimeRemainingPipe,
        TimeLimitPipe,
        SameDayDeliveryInOffModeDirective
    ]
})
export class SameDayDeliveryModule {}
